import React from "react";
import { IoMdClose } from "react-icons/io";
import { MediaHeaderContainer } from "../styled/common";

const MediaHeader = ({ uploader, onClose }) => {
  return (
    <MediaHeaderContainer>
      <span>{uploader}</span>
      <button className="close" onClick={onClose}>
        <IoMdClose />
      </button>
    </MediaHeaderContainer>
  );
};

export default MediaHeader;
